import { useIntl } from 'react-intl';
import Modal from '../../../../../../../components/Modal';
import AccionaBigUploadButton from '../../../../../../../components/AccionaBigUploadButton';
import PropTypes from 'prop-types';

const UploadDeliveryNoteModal = ({ onClick, open, onCancel }) => {
  const intl = useIntl();
  return (
    <Modal
      title={intl
        .formatMessage({
          id: 'pages.quality.ocr.templates.uploadDeliveryNoteModal.title',
        })
        .toUpperCase()}
      open={open}
      width="50vw"
      backgroundColor="rgb(241, 241, 241)"
      closable
      onCancel={onCancel}
    >
      <div
        style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          padding: '0 1em 1em 1em',
        }}
      >
        <AccionaBigUploadButton
          icon="delivery-ocr"
          type="deliveryNote"
          id="uploadDelivery"
          onClick={(event) => {
            onClick(event, 'delivery');
          }}
          msg={intl.formatMessage({
            id: `pages.quality.ocr.templates.uploadDeliveryNoteModal.button.deliveryHA`,
          })}
        />
        <AccionaBigUploadButton
          icon="delivery-ocr"
          type="deliveryNote"
          id="uploadDeliveryPC"
          onClick={(event) => {
            onClick(event, 'deliveryPC');
          }}
          msg={intl.formatMessage({
            id: `pages.quality.ocr.templates.uploadDeliveryNoteModal.button.deliveryPC`,
          })}
        />
      </div>
    </Modal>
  );
};

UploadDeliveryNoteModal.defaultProps = {
  onClick: () => {},
  open: false,
  onCancel: () => {},
};

UploadDeliveryNoteModal.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool,
  onCancel: PropTypes.func,
};

export default UploadDeliveryNoteModal;
